import styles from "./styles.module.scss";
import { Col, Divider, Row, Space, Tag } from "antd";
import { Button } from "@shared/ui/Button";
import { useUnlinkBrandFromBilling } from "@entities/billingBrand/lib/hooks/useUnlinkBrandFromBilling";

import { DeleteOutlined } from "@ant-design/icons";
import { IBrandBilling } from "@shared/lib/types/brandBilling";
import { useEffect, useState } from "react";

interface LinkedBrandsProps {
  linkedBrands: IBrandBilling["linkToBrands"];
  billingId: string;
  onAddClick: () => void;
}

export function LinkedBrands({
  linkedBrands,
  billingId,
  onAddClick,
}: LinkedBrandsProps) {
  const { unlink, isUnlinking, isUnlinked } = useUnlinkBrandFromBilling();

  const [selectedBrand, setSelectedBrand] = useState<string>("");

  const handleUnlink = (brandId: string) => {
    setSelectedBrand(brandId);
    unlink({ billingId, brandId });
  };

  useEffect(() => {
    if (isUnlinked) {
      setSelectedBrand("");
    }
  }, [isUnlinked]);

  return (
    <div className={styles.cardLinked}>
      <Space
        style={{
          justifyContent: "space-between",
          width: "100%",
          alignItems: "start",
          marginBottom: "12px",
        }}
      >
        <div className={styles.permTitle}>Linked Brands</div>
        <Button variant="outlined" size="small" onClick={onAddClick}>
          Add New
        </Button>
      </Space>

      <Divider style={{ margin: 0, marginBottom: 16 }} />
      {linkedBrands.length ? (
        <div className={styles.permContent}>
          {linkedBrands.map((brand) => (
            <>
              <BrandTile
                brand={brand}
                onUnlink={handleUnlink}
                isUnlinking={isUnlinking}
                selectedBrandId={selectedBrand}
              />
              <Divider style={{ margin: 0 }} />
            </>
          ))}
        </div>
      ) : (
        <div>No brands linked</div>
      )}
    </div>
  );
}

function BrandTile({
  brand,
  onUnlink,
  isUnlinking,
  selectedBrandId,
}: {
  brand: { name: string; _id: string };
  selectedBrandId: string;
  onUnlink: (brandId: string) => void;
  isUnlinking: boolean;
}) {
  return (
    <Row style={{ width: "100%" }} justify={"space-between"}>
      <Col span={20}>
        <div>
          <div className={styles.permItemTitle}>{brand.name}</div>
        </div>
      </Col>

      <Col
        span={1}
        style={{
          justifyItems: "flex-end",
          display: "flex",
          height: "max-content",
        }}
      >
        <Button
          type="text"
          danger
          icon={<DeleteOutlined />}
          onClick={() => onUnlink(brand._id)}
          loading={isUnlinking && brand._id === selectedBrandId}
        />
      </Col>
    </Row>
  );
}
